// extracted by mini-css-extract-plugin
export default {"header":"Table_header__3zbS0","link":"Table_link__+Spdh","active":"Table_active__sP8eR","inactive":"Table_inactive__3dPmX"};